import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [
        "row",
        "deleteButton"
    ];

    connect()
    {
        this.testDetailsWrapper = this.rowTarget.parentElement.parentElement;

        let urlParams = new URLSearchParams(window.location.search);
        this.devNum = urlParams.get("active_dev_num");
        this.siteNum = this.data.get("siteNum");

    }

    async loadPointData()
    {
        let response = await fetch(window.App.prefixedUrl(`/devices/${this.devNum}/point-list`));
        let data = await response.json();

        this.testDetailsWrapper.CACHED_DEVICE_POINT_LIST = data;
        return data;
    }

    createPointResultItems(data)
    {
        let items = data.map(pointData =>
        {
            let item = document.createElement("div");

            let ecDesc = pointData.event_code_with_descr;
            let eventCodeSpan = ecDesc ? `<span style="font-weight: normal;"> | ${ecDesc}</span>` : "";
            let infoSpan = `<span>${pointData.point}${eventCodeSpan}</span>`;
            let descSpan = pointData.point_description ? `<span>${pointData.point_description}</span>` : "";

            item.innerHTML = `<div class="item">${infoSpan}${descSpan}</div>`;

            let pointItem = item.firstElementChild;
            pointItem.addEventListener("click", e => this.resultItemClick(e, pointData));

            return pointItem;
        });

        return items;
    }

    resultItemClick(event, item)
    {
        this.pointTFTarget.value = item.point;
        this.pointSearchTarget.classList.add("toast-invisible");
    }

    showPointResults(data)
    {
        if(!data.length) return;
        let items = this.createPointResultItems(data);
        this.pointSearchTarget.innerHTML = "";
        this.pointSearchTarget.append(...items);
        this.pointSearchTarget.classList.remove("toast-invisible");
    }

    async loadPoints()
    {
        if (!this.pointSearchTarget.classList.contains("toast-invisible")) return;

        this.pointSearchTarget.classList.add("toast-invisible");

        if (this.testDetailsWrapper.CACHED_DEVICE_POINT_LIST)
        {
            this.showPointResults(this.testDetailsWrapper.CACHED_DEVICE_POINT_LIST);
            return;
        }

        this.pointLoaderTarget.classList.remove("hidden");

        let data = await this.loadPointData();
        this.showPointResults(data);

        this.pointLoaderTarget.classList.add("hidden");

    }

    filterPointResultElements(originalQuery)
    {
        let query = originalQuery.toLowerCase();
        let filteredResults = this.testDetailsWrapper.CACHED_DEVICE_POINT_LIST.filter(point =>
        {
            if (point.event_code_with_descr && point.event_code_with_descr.toLowerCase().includes(query) ||
                point.point.includes(query) ||
                point.point_description && point.point_description.toLowerCase().includes(query)
            ) return true;
            else return false;
        })

        return filteredResults;
    }


    async loadEventCodes()
    {
        if (!this.eventCodeSearchTarget.classList.contains("toast-invisible")) return;

        this.eventCodeSearchTarget.classList.add("toast-invisible");

        if (this.testDetailsWrapper.CACHED_EVENT_CODE_LIST)
        {
            this.showEventCodeResults(this.testDetailsWrapper.CACHED_EVENT_CODE_LIST);
            return;
        }

        this.eventCodeLoaderTarget.classList.remove("hidden");

        let data = await this.loadEventCodeData();
        this.showEventCodeResults(data);

        this.eventCodeLoaderTarget.classList.add("hidden");
    }

    createEventCodeResultItems(data)
    {
        let items = data.map(eventCodeData =>
        {
            let item = document.createElement("div");

            let desc = eventCodeData.event_code_description;
            let eventCodeSpan = desc ? `<span style="font-weight: normal;"> | ${desc}</span>` : "";
            let infoSpan = `<span>${eventCodeData.event_code}${eventCodeSpan}</span>`;

            let descSpan = "<span>";
            if (eventCodeData.serv_type) descSpan += `Service type: ${eventCodeData.serv_type}` + (eventCodeData.act_plan_description ? " | " : "");
            if (eventCodeData.act_plan_description) descSpan += `Default Action Plan: ${eventCodeData.act_plan_description}`;
            descSpan += "<span>"

            item.innerHTML = `<div class="item">${infoSpan}${descSpan}</div>`;

            let eventCodeItem = item.firstElementChild;
            eventCodeItem.addEventListener("click", e => this.eventCodeResultItemClick(e, eventCodeData));

            return eventCodeItem;
        });

        return items;
    }

    eventCodeResultItemClick(event, item)
    {
        this.eventCodeTFTarget.value = item.event_code;
        this.eventCodeSearchTarget.classList.add("toast-invisible");
    }

    showEventCodeResults(data)
    {
        let items = this.createEventCodeResultItems(data);
        this.eventCodeSearchTarget.innerHTML = "";
        this.eventCodeSearchTarget.append(...items);
        this.eventCodeSearchTarget.classList.remove("toast-invisible");
    }

    async loadEventCodeData()
    {
        let response = await fetch(window.App.prefixedUrl(`/devices/${this.devNum}/event-code-list`));
        let data = await response.json();

        this.testDetailsWrapper.CACHED_EVENT_CODE_LIST = data;
        return data;
    }

    filterEventCodeResultElement(originalQuery)
    {
        let query = originalQuery.toLowerCase();
        let filteredResults = this.testDetailsWrapper.CACHED_EVENT_CODE_LIST.filter(eventCode =>
        {
            let actPlanDesc = eventCode.act_plan_description;

            if (actPlanDesc && actPlanDesc.toLowerCase().includes(query) ||
                eventCode.serv_type && eventCode.serv_type.toLowerCase().includes(query) ||
                eventCode.event_code.toLowerCase().includes(query) ||
                eventCode.event_code_description && eventCode.event_code_description.toLowerCase().includes(query)
            )
                return true;
            else return false;
        })

        return filteredResults;
    }


    async loadServices()
    {
        let response = await fetch(window.App.prefixedUrl(`/devices/${this.devNum}/service-type-list`));
        let data = await response.json();

        this.testDetailsWrapper.CACHED_SERVICE_TYPES = data;
        return data;
    }

    createServiceTypeElements(data)
    {
        let items = data.map(service =>
        {
            let item = document.createElement("div");

            item.innerHTML = `<div class="item"><span>${service.serv_type}</span><span>${service.service_type_description}</span></div>`;

            let serviceItem = item.firstElementChild;
            serviceItem.addEventListener("click", e => this.serviceResultItemClick(e, service));

            return serviceItem;
        });

        return items;
    }

    serviceResultItemClick(event, item)
    {
        this.serviceTFTarget.value = item.serv_type;
        this.serviceSearchTarget.classList.add("toast-invisible");
    }

    showServiceResults(data)
    {
        let items = this.createServiceTypeElements(data);
        this.serviceSearchTarget.innerHTML = "";
        this.serviceSearchTarget.append(...items);
        this.serviceSearchTarget.classList.remove("toast-invisible");
    }

    async loadServiceTypes()
    {
        if (!this.serviceSearchTarget.classList.contains("toast-invisible")) return;

        this.serviceSearchTarget.classList.add("toast-invisible");

        if (this.testDetailsWrapper.CACHED_SERVICE_TYPES)
        {
            this.showServiceResults(this.testDetailsWrapper.CACHED_SERVICE_TYPES);
            return;
        }

        this.serviceLoaderTarget.classList.remove("hidden");

        let data = await this.loadServices();
        this.showServiceResults(data);

        this.serviceLoaderTarget.classList.add("hidden");

    }

    filterServiceTypes(originalQuery)
    {
        let query = originalQuery.toLowerCase();
        let filteredResults = this.testDetailsWrapper.CACHED_SERVICE_TYPES.filter(service =>
        {
            if (service.serv_type.toLowerCase().includes(query) ||
                service.service_type_description.toLowerCase().includes(query)
            ) return true;
            else return false;
        })

        return filteredResults;
    }
}